<template>
    <div class="page-detailTask">
        <div class='detail-head'>
            <img class="close" @click="back" src="~assets/image/back-close.svg">
        </div>
        <taskDetail class="detail-main" @openDoc="openDocument"></taskDetail>
        <downDocument @close="closeDocument" :flag="docTpl_flag" ></downDocument>
    </div>

</template>

<script>
    import taskDetail from "./detailTask/task-detail.vue";
    import downDocument from "./detailTask/downDocument.vue"

    export default {
        components:{
            taskDetail,
            downDocument,
        },

        data(){
            return {
                docTpl_flag:false,   //下载模板控制器
            }
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
            console.log(`to-path ${to.path}`);
            // let res = this.$form.leave({name:"task_detail",path:to.path},this.doc_mul_flag);
            // next(res);
            next();
        },

        methods:{
            back(){  //关闭回退
                this.$router.go(-1);
            },
            closeDocument(){  //关闭模板
                this.docTpl_flag = false;
            },
            openDocument(){  //打开模板
                this.docTpl_flag = true;
            },
        }

    }
</script>

<style lang="less">
    .page-detailTask{
        height:100%;
        background:#fff;
        box-sizing: border-box;
        // position: relative;
        @head-h:40px;

        .detail-head{
            height: @head-h;
            position: relative;
            box-sizing: border-box;
            // border-bottom: 1px solid #979797;
            box-shadow:0 1px 4px 0 #c3c6c9;
            // 退出按钮
            .close{
                position: absolute;
                display:block;
                height:15px;
                width:15px;
                right:30px;
                cursor:pointer;
                z-index:3;
                top:50%;
                transform: translateY(-50%);
            }
        }

        .detail-main{
            height:calc(~"100% - @{head-h}");
        }

    }
</style>



// WEBPACK FOOTER //
// page-detailTask.vue?a4073d54